import React from "react";

export default function ResultDetectedInput({ value, onChange }) {
  return <input type="checkbox" checked={value} onChange={e => onChange(e.target.checked)} />;
}
